import React from 'react';
import { Typography, Card, Space, Avatar, Row, Col } from 'antd';
import { 
  SafetyOutlined, 
  ThunderboltOutlined, 
  CloudOutlined, 
  TeamOutlined 
} from '@ant-design/icons';
import { useLanguage } from '../i18n/LanguageContext';

const { Title, Paragraph } = Typography;

const AboutPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="container">
      <Typography>
        <Title>{t('about.title')}</Title>
        <Paragraph>
          {t('about.welcome')}
        </Paragraph>
      </Typography>

      <Card style={{ marginBottom: 24 }}>
        <Title level={3}>{t('about.mission.title')}</Title>
        <Paragraph>
          {t('about.mission.content')}
        </Paragraph>
      </Card>

      <Title level={3}>{t('about.why.title')}</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Card>
            <Space>
              <ThunderboltOutlined style={{ fontSize: 24, color: '#1890ff' }} />
              <div>
                <Title level={4}>{t('about.fast.title')}</Title>
                <Paragraph>
                  {t('about.fast.content')}
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card>
            <Space>
              <SafetyOutlined style={{ fontSize: 24, color: '#52c41a' }} />
              <div>
                <Title level={4}>{t('about.privacy.title')}</Title>
                <Paragraph>
                  {t('about.privacy.content')}
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card>
            <Space>
              <CloudOutlined style={{ fontSize: 24, color: '#722ed1' }} />
              <div>
                <Title level={4}>{t('about.noinstall.title')}</Title>
                <Paragraph>
                  {t('about.noinstall.content')}
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card>
            <Space>
              <TeamOutlined style={{ fontSize: 24, color: '#fa8c16' }} />
              <div>
                <Title level={4}>{t('about.userfriendly.title')}</Title>
                <Paragraph>
                  {t('about.userfriendly.content')}
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }}>
        <Title level={3}>{t('about.team.title')}</Title>
        <Paragraph>
          {t('about.team.content')}
        </Paragraph>
        
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} sm={8}>
            <Card bordered={false} style={{ textAlign: 'center' }}>
              <Avatar size={64} style={{ backgroundColor: '#1890ff' }}>J</Avatar>
              <Title level={4} style={{ marginTop: 16 }}>Jacky Wang</Title>
              <Paragraph type="secondary">{t('about.team.lead')}</Paragraph>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card bordered={false} style={{ textAlign: 'center' }}>
              <Avatar size={64} style={{ backgroundColor: '#52c41a' }}>J</Avatar>
              <Title level={4} style={{ marginTop: 16 }}>Jady Kim</Title>
              <Paragraph type="secondary">{t('about.team.designer')}</Paragraph>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card bordered={false} style={{ textAlign: 'center' }}>
              <Avatar size={64} style={{ backgroundColor: '#fa8c16' }}>M</Avatar>
              <Title level={4} style={{ marginTop: 16 }}>Mohammad Ali</Title>
              <Paragraph type="secondary">{t('about.team.expert')}</Paragraph>
            </Card>
          </Col>
        </Row>
      </Card>

      <Card style={{ marginTop: 24 }}>
        <Title level={3}>{t('about.philosophy.title')}</Title>
        <Paragraph>
          {t('about.philosophy.content1')}
        </Paragraph>
        <Paragraph>
          {t('about.philosophy.content2')}
        </Paragraph>
        <Paragraph>
          {t('about.philosophy.content3')}
        </Paragraph>
      </Card>
    </div>
  );
};

export default AboutPage; 